import { render, staticRenderFns } from "./FeesDialog.vue?vue&type=template&id=6fdb9fc8"
import script from "./FeesDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./FeesDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports